function ThemeAnimation() {
    return null;
}

export default ThemeAnimation;
